

// Bump this string whenever Privacy Policy or EULA changes materially.
// Existing users with a different version will be shown the consent gate again.
const CONSENT_VERSION = "2026-03";

// Expense categories — shared between InboxAddExpenseForm and ManualExpenseSection
const EXPENSE_CATEGORIES = [
  { value: "materials", label: "Materials" },
  { value: "subcontractor", label: "Subcontractor" },
  { value: "equipment", label: "Equipment" },
  { value: "permits", label: "Permits" },
  { value: "other", label: "Other" },
];

export { CONSENT_VERSION, EXPENSE_CATEGORIES };
